import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogle, loginWithAppleToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const search = location.search || window.location.search || "";
    const gMatch = hash.match(/session_id=([^&]+)/);
    const appleToken = new URLSearchParams(search).get("apple_token");
    // Strip the token from the URL immediately (keep just the path).
    window.history.replaceState(null, "", window.location.pathname);

    const run = appleToken
      ? loginWithAppleToken(appleToken)
      : gMatch
        ? loginWithGoogle(decodeURIComponent(gMatch[1]))
        : null;

    if (!run) {
      navigate("/auth", { replace: true });
      return;
    }
    run
      .then((data) => {
        toast.success("Welcome to aiBLACK");
        navigate("/app", { replace: true, state: { user: data } });
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/auth", { replace: true }), 1500);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0f]" data-testid="auth-callback">
      <div className="flex gap-2">
        <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
      </div>
    </div>
  );
}
